import React from 'react';
import SireList from 'components/Tvendo/Common/Sire/SireList';
import { ConstantPermissions } from 'contexts/useConstant';

export default function PurchaseSire() {
  return (
    <SireList
      entity="purch/sire"
      title="Compras SIRE"
      permission={ConstantPermissions.PURCH_SIRE_CONCILIATIONS_STORE}
      updatePermission={ConstantPermissions.PURCH_SIRE_CONCILIATIONS_UPDATE}
      deletePermission={ConstantPermissions.PURCH_SIRE_CONCILIATIONS_DESTROY}
      excelName="sire_comprobante_compras"
    />
  );
}
